// src/components/ProfileFilter/ProfileFilter.js

import React, { useEffect, useMemo, useState } from 'react';
import './ProfileFilter.css';
import Stats from '../Stats/Stats';
import SubscriptionInfo from '../SubscriptionInfo/SubscriptionInfo';
import GameHistory from '../GameHistory/GameHistory';
import UpcomingGames from '../UpcomingGames/UpcomingGames';
import { SUBSCRIPTIONS_ENABLED } from '../../utils/features';

const ProfileFilter = ({
  games = [],
  user,
  initialTab,
  suspendStats = false,
  showSubscription = SUBSCRIPTIONS_ENABLED,
  showUpcomingGames = true,
  statsProps = {},
  refreshTokens,
  handleLogout,
}) => {
  // Stats and games are one view now: the game history sits under the points
  // chart, before the leaderboard. 'games' is still accepted from ?tab=games
  // links and simply opens that view. Membership keeps its own tab, so the tab
  // menu only appears when subscriptions are switched on.
  const validTabs = useMemo(
    () => (showSubscription ? ['ranking', 'subscription'] : ['ranking']),
    [showSubscription]
  );
  const safeInitial = validTabs.includes(initialTab) ? initialTab : 'ranking';
  const [activeTab, setActiveTab] = useState(safeInitial);

  // Update if parent changes initialTab (e.g., via query param)
  useEffect(() => {
    if (validTabs.includes(initialTab)) {
      setActiveTab(initialTab);
      return;
    }

    setActiveTab('ranking');
  }, [initialTab, validTabs]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="profile-filter-container">
      {/* Tab Menu: only when there is more than one view to choose from. */}
      {validTabs.length > 1 && (
        <div className="tab-menu">
          <span
            className={activeTab === 'ranking' ? 'active' : ''}
            onClick={() => handleTabClick('ranking')}
          >
            STATS
          </span>
          <span
            className={activeTab === 'subscription' ? 'active' : ''}
            onClick={() => handleTabClick('subscription')}
          >
            MEMBERSHIP
          </span>
        </div>
      )}

      {/* Tab Content */}
      <div className="tab-content">
        {activeTab === 'ranking' && !suspendStats && (
          <Stats
            refreshTokens={refreshTokens}
            handleLogout={handleLogout}
            {...statsProps}
            beforeLeaderboard={
              <div className="profile-games">
                <GameHistory games={games} />
                {showUpcomingGames && <UpcomingGames games={games} />}
              </div>
            }
          />
        )}
        {showSubscription && activeTab === 'subscription' && <SubscriptionInfo user={user} />}
      </div>
    </div>
  );
};

export default ProfileFilter;
